
import { FETCH_RESERV_SUCCESS, FETCH_RESERV_FAILURE,REDIRECT_TO_LOGIN } from './actionsTypes';

const initialState = {
  reservData: [],
  error: null,
  redirectToLoginPage: false,
};

const reservReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_RESERV_SUCCESS:
      return {
        ...state,
        reservData: action.payload.reservData,
        error: null,
      };
    case FETCH_RESERV_FAILURE:
      return {
        ...state,
        reservData: [],
        error: action.payload.error,
      };
    case REDIRECT_TO_LOGIN:
        return {
            ...state,
            redirectToLoginPage: true,
        };
    default:
      return state;
  }
};

export default reservReducer;
